import { render, staticRenderFns } from "./Standfirst.vue?vue&type=template&id=6506ab18&scoped=true&"
var script = {}
import style0 from "./Standfirst.vue?vue&type=style&index=0&id=6506ab18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506ab18",
  null
  
)

export default component.exports